module.exports = __webpack_public_path__ + "img/hd12.950571b2.png";